// @ts-nocheck
import { Globe } from 'lucide-react';
import { Section, Field, Message, useStudio, useNode, c } from '../ui';


const DEFAULT_CODE = 'en-IN';

export default function LanguageSection({ next, onNext, value, onChange }) {
  const { data } = useStudio();
  const node = useNode('languages');
  const { items, loading, error } = data.languages;

  const pick = (code) => {
    const match = items.find((l) => l.code === code);
    if (!code) return;
    onChange({ id: match?.id ?? null, code, name: match?.language || match?.name || code });
  };

  return (
    <Section
      id="languages"
      icon={Globe}
      title="Language"
      sub="The language your agent speaks."
      tag={node.ok ? 'done' : 'optional'}
      ok={node.ok}
      next={next('languages')}
      onNext={onNext}
    >
      <Field label="Agent language" htmlFor="ags-lang" style={{ maxWidth: 340, margin: 0 }} note={loading ? 'Loading languages…' : 'The agent speaks and listens in this language.'}>
        <select id="ags-lang" className={c('ctl')} value={value || DEFAULT_CODE} disabled={loading || !!error} onChange={(e) => pick(e.target.value)}>
          {!items.some((l) => l.code === DEFAULT_CODE) && <option value={DEFAULT_CODE}>English (India)</option>}
          {items.map((l) => (
            <option key={l.id} value={l.code}>
              {l.language || l.name}
            </option>
          ))}
        </select>
      </Field>
      <Message error={error} />
    </Section>
  );
}
